import { _ as t } from "../internals/export.js";
import { g as r } from "../internals/get-built-in.js";
import { f as n } from "../internals/fails.js";
import { v as a } from "../internals/validate-arguments-length.js";
import { t as s } from "../internals/to-string.js";
import { u as i } from "../internals/url-constructor-detection.js";
var o = r("URL");
t({
  target: "URL",
  stat: !0,
  forced: !(i && n(function () {
    o.canParse();
  }))
}, {
  canParse: function canParse(t) {
    var r = a(arguments.length, 1),
      n = s(t),
      i = r < 2 || void 0 === arguments[1] ? void 0 : s(arguments[1]);
    try {
      return new o(n, i), !0;
    } catch (t) {
      return !1;
    }
  }
});